import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useHistory } from 'react-router'
import moment from 'moment-timezone'

//styles
import './Sensors.css'

// semantic ui react
import {
  Container,
  Header,
  Icon,
  Table,
  Loader
} from 'semantic-ui-react'

//graphql
import gql from 'graphql-tag'
import { useQuery } from '@apollo/react-hooks'

const SENSORS = gql`
query Sensors {
  me {
    id
    sensors {
      id
      serial
      model
      po_number
      license
      purchased_at
    }
  }
}
`

const Sensors = props => {
  // get sensors
  let { loading, called, error, data } = useQuery(SENSORS)
  // states
  let [sensors, setSensors] = useState([])
  // set sensors after load
  useEffect(() => {
    if (data && !loading && !error) {
      setSensors(data.me.sensors || [])
    }
  }, [data])

  const history = useHistory()
  const goToCreateSensor = () => {
    history.push('/sensors/create')
  }

  return (
    <Container className='Sensors'>
      <Header as='h3' floated='left'>
        <Icon name='video camera' />
        <Header.Content>
          Sensors
          <Header.Subheader>List of sensors:</Header.Subheader>
        </Header.Content>
      </Header>
      <Header as='a' floated='right' onClick={goToCreateSensor} className='add-sensor'>
        <Icon name='plus square outline' />Add a sensor
      </Header>
      {loading && called && (<Loader active>Loading sensors...</Loader>)}
      {!loading && (
        <Table celled striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Serial</Table.HeaderCell>
              <Table.HeaderCell>Model</Table.HeaderCell>
              <Table.HeaderCell>PO number</Table.HeaderCell>
              <Table.HeaderCell>License</Table.HeaderCell>
              <Table.HeaderCell>Purchased At</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {sensors && sensors.map(sensor => (
              <Table.Row key={sensor.id}>
                <Table.Cell><Link to={`/sensors/${sensor.id}`}>{sensor.serial}</Link></Table.Cell>
                <Table.Cell>{sensor.model}</Table.Cell>
                <Table.Cell>{sensor.po_number}</Table.Cell>
                <Table.Cell textAlign='center' collapsing>
                  {sensor.license ?
                    (<Icon name='check circle outline' color='green' />)
                    : (<Icon name='times circle outline' color='red' />)
                  }
                </Table.Cell>
                <Table.Cell>{sensor.purchased_at && moment(sensor.purchased_at).format('DD MMM YYYY')}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      )}
    </Container>
  )
}

export default Sensors
